import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const LightbulbOutlinedIcon: FC<SvgIconProps> = (props) => (
  <SvgIcon
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M10.0003 6.575L9.10863 8.125C8.90863 8.46667 9.07529 8.75 9.46696 8.75H10.5253C10.9253 8.75 11.0836 9.03333 10.8836 9.375L10.0003 10.925"
      strokeWidth="1.47692"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6.91696 15.0333V14.0667C5.00029 12.9083 3.42529 10.65 3.42529 8.25C3.42529 4.125 7.21696 0.891667 11.5003 1.825C13.3836 2.24167 15.0336 3.49167 15.892 5.21667C17.6336 8.71667 15.8003 12.4333 13.1086 14.0583V15.025C13.1086 15.2667 13.2003 15.825 12.3086 15.825H7.71696C6.80029 15.8333 6.91696 15.475 6.91696 15.0333Z"
      strokeWidth="1.47692"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.0835 18.3333C8.99183 17.7917 11.0085 17.7917 12.9168 18.3333"
      strokeWidth="1.47692"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
)
